/*
 * &LIVY — Intention Chain "Add a charm" pop-up.
 *
 * The reverse of the charm PDP's "Make it wearable" modal. After a successful
 * /cart/add of exactly ONE Intention Chain necklace, if the cart holds no
 * charms, open a slider of the 8 best-selling charms (rendered server-side by
 * sections/andlivy-chain-charm-upsell.liquid via the Section Rendering API).
 *
 * Rules:
 *   - Qualifying add: 1 line, title contains "intention chain", product type
 *     contains "necklace" (bracelets excluded), not a charm-builder line.
 *   - Any charm already in the cart (type Charm/Charms or _build_role=charm)
 *     → never show.
 *   - Once per session after dismiss or a charm add
 *     (sessionStorage 'andlivy-chain-upsell' = dismissed | added).
 *   - Reads a CLONE of the cart response, so the theme / Rebuy flows are
 *     untouched. Hides the Rebuy drawer while open.
 *
 * Loaded deferred from layout/theme.liquid. Plan: CHAIN_CHARM_UPSELL_PLAN.md.
 */
(function () {
  'use strict';
  if (window.__andlivyChainUpsellInit) return;
  window.__andlivyChainUpsellInit = true;

  var SESSION_KEY = 'andlivy-chain-upsell';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SECTION_URL = ROOT + 'collections/intention-charms?sort_by=best-selling&section_id=andlivy-chain-charm-upsell';
  var CART_ADD_RE = /\/cart\/add(\.js)?(\?|$|#)/;
  var FINISH_RE = /finish|metal|colou?r/i;
  // Options with more than this many values (Letter, Birthstone, Sign) start
  // unselected so nobody adds an "A" or "January" by accident.
  var MUST_CHOOSE_OVER = 3;

  var modalPromise = null;
  var modal = null;
  var labels = {};
  var products = [];
  var lastFocused = null;
  var checking = false;

  // ---------- helpers ----------
  function flagged() {
    try { return !!sessionStorage.getItem(SESSION_KEY); } catch (e) { return false; }
  }
  function setFlag(v) {
    try { sessionStorage.setItem(SESSION_KEY, v); } catch (e) {}
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[m];
    });
  }
  function isCharmLine(item) {
    var t = String(item.product_type || '').trim().toLowerCase();
    var role = item.properties && item.properties._build_role;
    return t === 'charm' || t === 'charms' || String(role || '').toLowerCase() === 'charm';
  }
  function isChainLine(item) {
    var title = String(item.product_title || item.title || '').toLowerCase();
    var type = String(item.product_type || '').toLowerCase();
    var props = item.properties || {};
    return title.indexOf('intention chain') !== -1 &&
      type.indexOf('necklace') !== -1 &&
      !props._build_id;
  }
  function finishOf(item) {
    // "Finely Finished Gold" / "Finely Finished Silver" live in options_with_values or variant_options.
    var vals = [];
    (item.options_with_values || []).forEach(function (o) { vals.push(o.value); });
    (item.variant_options || []).forEach(function (v) { vals.push(v); });
    if (item.variant_title) vals.push(item.variant_title);
    var s = vals.join(' ').toLowerCase();
    if (s.indexOf('gold') !== -1) return 'gold';
    if (s.indexOf('silver') !== -1) return 'silver';
    return null;
  }

  // ---------- detection ----------
  function onCartAddResponse(json) {
    if (!json || flagged() || checking) return;
    if (modal && modal.getAttribute('data-open') === 'true') return;
    var items = Array.isArray(json.items) ? json.items : [json];
    if (items.length !== 1 || !isChainLine(items[0])) return;
    var finish = finishOf(items[0]);
    checking = true;
    Promise.all([
      fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; }),
      loadModal()
    ]).then(function (res) {
      checking = false;
      var cart = res[0];
      if (!cart || !res[1]) return;
      if ((cart.items || []).some(isCharmLine)) return;
      if (flagged()) return;
      open(finish);
    }).catch(function (err) {
      checking = false;
      console.warn('[andlivy-chain-upsell]', err);
    });
  }

  var _fetch = window.fetch;
  if (typeof _fetch === 'function') {
    window.fetch = function (input, init) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || String(input || ''); } catch (e) {}
      var p = _fetch.apply(this, arguments);
      if (CART_ADD_RE.test(url)) {
        p.then(function (r) {
          if (!r || !r.ok) return;
          r.clone().json().then(onCartAddResponse).catch(function () {});
        }).catch(function () {});
      }
      return p;
    };
  }
  if (window.XMLHttpRequest && XMLHttpRequest.prototype.open) {
    var _open = XMLHttpRequest.prototype.open;
    var _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__acuUrl = url;
      return _open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (CART_ADD_RE.test(String(this.__acuUrl || ''))) {
        this.addEventListener('load', function () {
          if (this.status < 200 || this.status >= 300) return;
          try {
            var body = this.responseType === 'json' ? this.response : JSON.parse(this.responseText);
            onCartAddResponse(body);
          } catch (e) {}
        });
      }
      return _send.apply(this, arguments);
    };
  }

  // ---------- load the server-rendered section ----------
  function loadModal() {
    if (modalPromise) return modalPromise;
    modalPromise = fetch(SECTION_URL, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('section ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var root = doc.getElementById('andlivy-chain-charm-upsell');
        var styles = doc.querySelectorAll('style');
        if (!root) throw new Error('section markup missing');
        try { products = JSON.parse(root.querySelector('[data-acu-products]').textContent || '[]'); } catch (e) { products = []; }
        try { labels = JSON.parse(root.querySelector('[data-acu-labels]').textContent || '{}'); } catch (e) { labels = {}; }
        if (!products.length) return null;
        var host = document.createElement('div');
        host.className = 'acu-host';
        styles.forEach(function (s) { host.appendChild(document.importNode(s, true)); });
        host.appendChild(document.importNode(root, true));
        document.body.appendChild(host);
        modal = document.getElementById('andlivy-chain-charm-upsell');
        wireModal();
        return modal;
      })
      .catch(function (err) {
        modalPromise = null; // allow a retry on the next qualifying add
        console.warn('[andlivy-chain-upsell]', err);
        return null;
      });
    return modalPromise;
  }

  // Prefetch on an Intention Chain necklace PDP so the first open is instant.
  function maybePrefetch() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    var title = document.title.toLowerCase();
    var onChainPdp = /\/products\//.test(location.pathname) &&
      (title.indexOf('intention chain') !== -1) &&
      !(meta && meta.type && !/necklace/i.test(meta.type));
    if (!onChainPdp || flagged()) return;
    var go = function () { loadModal(); };
    if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 4000 });
    else setTimeout(go, 2500);
  }

  // ---------- cards ----------
  function swatchColor(value) {
    var v = String(value).toLowerCase();
    if (v.indexOf('antique') !== -1 && v.indexOf('gold') !== -1) return '#a8874f';
    if (v.indexOf('antique') !== -1 && v.indexOf('silver') !== -1) return '#8d8f93';
    if (v.indexOf('two') !== -1) return 'linear-gradient(135deg,#d9b56c 50%,#c9ccd1 50%)';
    if (v.indexOf('gold') !== -1) return '#d9b56c';
    if (v.indexOf('silver') !== -1) return '#c9ccd1';
    return '#ddd';
  }

  function renderCard(p, idx, preferredFinish) {
    var finishIdx = -1;
    p.options.forEach(function (name, i) { if (finishIdx === -1 && FINISH_RE.test(name)) finishIdx = i; });

    // Default selection: first available variant; finish matched to the chain.
    var avail = p.variants.filter(function (v) { return v.available; });
    var start = avail[0] || p.variants[0];
    if (preferredFinish && finishIdx !== -1) {
      var match = avail.filter(function (v) {
        var f = String(v.options[finishIdx]).toLowerCase();
        return f.indexOf(preferredFinish) !== -1 && f.indexOf('antique') === -1;
      })[0];
      if (match) start = match;
    }
    var selected = start.options.slice();
    p.options.forEach(function (name, i) {
      if (i === finishIdx) return;
      if (uniqueValues(p, i).length > MUST_CHOOSE_OVER) selected[i] = null;
    });

    var controls = p.options.map(function (name, i) {
      var values = uniqueValues(p, i);
      if (values.length < 2) return '';
      if (i === finishIdx) {
        return '<div class="acu-card__swatches" role="group" aria-label="' + esc(name) + '">' +
          values.map(function (val) {
            return '<button type="button" class="acu-swatch" data-acu-opt="' + i + '" data-value="' + esc(val) + '"' +
              ' aria-pressed="' + (selected[i] === val ? 'true' : 'false') + '">' +
              '<span class="acu-swatch__dot" style="background:' + swatchColor(val) + '"></span>' +
              esc(val.replace(/^Finely Finished\s+/i, '')) + '</button>';
          }).join('') + '</div>';
      }
      var id = 'acu-' + p.id + '-' + i;
      return '<label class="acu-card__select-label" for="' + id + '">' + esc(name) + '</label>' +
        '<select class="acu-card__select" id="' + id + '" data-acu-opt="' + i + '">' +
        (selected[i] == null ? '<option value="" selected disabled>Choose ' + esc(name.toLowerCase()) + '</option>' : '') +
        values.map(function (val) {
          return '<option value="' + esc(val) + '"' + (selected[i] === val ? ' selected' : '') + '>' + esc(val) + '</option>';
        }).join('') + '</select>';
    }).join('');

    var rating = '';
    if (p.rating_count > 0) {
      var rv = Number(p.rating_value || 0).toFixed(1).replace(/\.0$/, '');
      rating = '<p class="acu-card__rating"><span class="acu-card__stars" style="--rating:' + Number(p.rating_value || 0) +
        '" role="img" aria-label="' + rv + ' out of 5 stars"></span><span>' + rv + ' (' + p.rating_count + ')</span></p>';
    }

    return '<article class="acu-card" data-acu-card="' + idx + '" aria-label="' + esc(p.title) + '">' +
      '<a class="acu-card__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
        '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="600" height="600" data-acu-img>' +
        '<span class="acu-card__check">✓</span></a>' +
      '<div class="acu-card__inner">' +
        '<h3 class="acu-card__title"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3>' +
        '<div class="acu-card__meta"><p class="acu-card__price" data-acu-price></p>' + rating + '</div>' +
        controls +
        '<button type="button" class="acu-card__cta" data-acu-add></button>' +
      '</div></article>';
  }

  function uniqueValues(p, i) {
    var seen = [];
    p.variants.forEach(function (v) { if (seen.indexOf(v.options[i]) === -1) seen.push(v.options[i]); });
    return seen;
  }

  // Card state lives on the element: selected option values array.
  function syncCard(card) {
    var p = products[+card.getAttribute('data-acu-card')];
    var sel = card.__acuSel;
    var exact = null;
    if (sel.every(function (x) { return x != null; })) {
      exact = p.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      })[0] || null;
    }
    // Best visual match for a partial selection (e.g. finish chosen, letter not yet).
    var partial = exact || p.variants.filter(function (v) {
      return v.options.every(function (o, i) { return sel[i] == null || o === sel[i]; });
    })[0] || p.variants[0];

    var img = card.querySelector('[data-acu-img]');
    var src = (exact && exact.image) || partial.image || p.image;
    if (img && src && img.getAttribute('src') !== src) img.setAttribute('src', src);
    card.querySelector('[data-acu-price]').textContent = partial.price;

    // Mark swatches / select options that are sold out with the other picks.
    card.querySelectorAll('[data-acu-opt]').forEach(function (ctrl) {
      var i = +ctrl.getAttribute('data-acu-opt');
      var check = function (val) {
        return p.variants.some(function (v) {
          return v.available && v.options.every(function (o, j) { return j === i ? o === val : (sel[j] == null || o === sel[j]); });
        });
      };
      if (ctrl.tagName === 'SELECT') {
        Array.prototype.forEach.call(ctrl.options, function (opt) {
          if (!opt.value) return;
          var ok = check(opt.value);
          opt.textContent = opt.value + (ok ? '' : ' — sold out');
        });
      } else {
        var val = ctrl.getAttribute('data-value');
        ctrl.setAttribute('aria-pressed', sel[i] === val ? 'true' : 'false');
        ctrl.classList.toggle('is-unavailable', !check(val));
      }
    });

    var btn = card.querySelector('[data-acu-add]');
    if (card.classList.contains('is-added')) return;
    btn.classList.remove('is-error');
    var missing = sel.indexOf(null);
    if (missing !== -1) {
      btn.disabled = true;
      btn.textContent = 'Choose ' + p.options[missing].toLowerCase();
      btn.removeAttribute('data-variant-id');
    } else if (!exact || !exact.available) {
      btn.disabled = true;
      btn.textContent = labels.sold_out || 'Sold out';
      btn.removeAttribute('data-variant-id');
    } else {
      btn.disabled = false;
      btn.textContent = labels.add || 'Add to bag';
      btn.setAttribute('data-variant-id', exact.id);
    }
  }

  function addCharm(card, btn) {
    var id = btn.getAttribute('data-variant-id');
    if (!id || card.classList.contains('is-added')) return;
    btn.disabled = true;
    btn.textContent = labels.adding || 'Adding…';
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart-add ' + r.status);
      return r.json();
    }).then(function () {
      card.classList.add('is-added');
      btn.disabled = true;
      btn.textContent = labels.added || 'Added ✓';
      card.querySelectorAll('[data-acu-opt]').forEach(function (c) { c.disabled = true; });
      setFlag('added');
      refreshCart();
    }).catch(function (err) {
      console.error('[andlivy-chain-upsell]', err);
      btn.classList.add('is-error');
      btn.textContent = labels.failed || 'Couldn’t add — try again';
      setTimeout(function () { syncCard(card); }, 2200);
    });
  }

  function refreshCart() {
    fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('[data-js-cart-count], [data-cart-count], .cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        try { document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })); } catch (e) {}
      }).catch(function () {});
    try {
      if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.fetchCart === 'function') window.Rebuy.Cart.fetchCart();
    } catch (e) {}
  }

  // ---------- slider ----------
  var track, prevBtn, nextBtn, dotsWrap;

  function step() {
    var card = track.querySelector('.acu-card');
    if (!card) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }
  function positions() {
    var s = step();
    return Math.max(1, Math.round((track.scrollWidth - track.clientWidth) / s) + 1);
  }
  function current() { return Math.round(track.scrollLeft / step()); }
  function updateNav() {
    // Track padding leaves a few px past the last snap point; treat that as the end.
    var max = track.scrollWidth - track.clientWidth - 8;
    prevBtn.disabled = track.scrollLeft <= 8;
    nextBtn.disabled = track.scrollLeft >= max;
    var n = positions();
    if (dotsWrap.children.length !== n) {
      dotsWrap.innerHTML = n > 1 ? new Array(n + 1).join('<span class="acu__dot"></span>') : '';
    }
    var c = Math.min(n - 1, current());
    Array.prototype.forEach.call(dotsWrap.children, function (d, i) { d.classList.toggle('is-active', i === c); });
  }
  function scrollToX(x) {
    x = Math.max(0, Math.min(x, track.scrollWidth - track.clientWidth));
    var from = track.scrollLeft, dist = x - from, t0 = null, dur = 320;
    if (Math.abs(dist) < 1) return;
    // Mandatory snap cancels programmatic smooth scroll in Chromium; animate by hand.
    track.style.setProperty('scroll-snap-type', 'none', 'important');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function frame(ts) {
      if (t0 == null) t0 = ts;
      var k = reduce ? 1 : Math.min(1, (ts - t0) / dur);
      var e = 1 - Math.pow(1 - k, 3);
      track.scrollLeft = from + dist * e;
      if (k < 1) requestAnimationFrame(frame);
      else requestAnimationFrame(function () { track.style.removeProperty('scroll-snap-type'); updateNav(); });
    }
    requestAnimationFrame(frame);
  }
  function page(dir) {
    var s = step();
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    var perView = Math.max(1, Math.floor((track.clientWidth + gap + 1) / s));
    var max = track.scrollWidth - track.clientWidth;
    var x = (current() + dir * perView) * s;
    if (x > max - s / 2) x = max;
    scrollToX(x);
  }

  // ---------- open / close ----------
  function hideDrawer() {
    try {
      if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.hide === 'function') window.Rebuy.SmartCart.hide();
    } catch (e) {}
    document.body.classList.remove('quick-cart-open', 'drawer-open');
  }
  function openDrawer() {
    try {
      if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.fetchCart === 'function') window.Rebuy.Cart.fetchCart();
    } catch (e) {}
    try {
      if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
        window.Rebuy.SmartCart.show();
        return;
      }
    } catch (e) {}
    window.location.href = ROOT + 'cart';
  }

  function open(finish) {
    if (!modal) return;
    lastFocused = document.activeElement;
    track.innerHTML = products.map(function (p, i) { return renderCard(p, i, finish); }).join('');
    track.querySelectorAll('.acu-card').forEach(function (card) {
      var p = products[+card.getAttribute('data-acu-card')];
      var sel = [];
      p.options.forEach(function (_, i) {
        var sw = card.querySelector('.acu-swatch[data-acu-opt="' + i + '"][aria-pressed="true"]');
        var se = card.querySelector('select[data-acu-opt="' + i + '"]');
        if (sw) sel[i] = sw.getAttribute('data-value');
        else if (se) sel[i] = se.value || null;
        else sel[i] = p.variants[0].options[i];
      });
      card.__acuSel = sel;
      syncCard(card);
    });
    track.scrollLeft = 0;
    hideDrawer();
    modal.setAttribute('data-open', 'true');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('acu-open');
    requestAnimationFrame(function () {
      updateNav();
      var first = modal.querySelector('.acu__close');
      if (first) first.focus();
    });
    try { window.dispatchEvent(new CustomEvent('andlivy:chain-upsell:open')); } catch (e) {}
  }

  function close(reason) {
    if (!modal || modal.getAttribute('data-open') !== 'true') return;
    modal.setAttribute('data-open', 'false');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('acu-open');
    if (!flagged()) setFlag('dismissed');
    if (reason === 'view-cart') {
      setTimeout(openDrawer, 200);
    } else {
      // Rebuy may have auto-opened behind us on a charm add; "keep shopping" means stay put.
      hideDrawer();
    }
    if (lastFocused && lastFocused.focus) { try { lastFocused.focus(); } catch (e) {} }
  }

  function wireModal() {
    track = modal.querySelector('[data-acu-track]');
    prevBtn = modal.querySelector('[data-acu-prev]');
    nextBtn = modal.querySelector('[data-acu-next]');
    dotsWrap = modal.querySelector('[data-acu-dots]');

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-acu-close]')) return close('dismiss');
      if (e.target.closest('[data-acu-view-cart]')) return close('view-cart');
      if (e.target.closest('[data-acu-all]')) {
        // Leaving for the Charms collection counts as an answer: don't re-prompt this session.
        if (!flagged()) setFlag('dismissed');
        return;
      }
      if (e.target.closest('[data-acu-prev]')) return page(-1);
      if (e.target.closest('[data-acu-next]')) return page(1);
      var sw = e.target.closest('.acu-swatch');
      if (sw && !sw.disabled) {
        var card = sw.closest('.acu-card');
        card.__acuSel[+sw.getAttribute('data-acu-opt')] = sw.getAttribute('data-value');
        return syncCard(card);
      }
      var add = e.target.closest('[data-acu-add]');
      if (add && !add.disabled) addCharm(add.closest('.acu-card'), add);
    });
    modal.addEventListener('change', function (e) {
      var se = e.target.closest('select[data-acu-opt]');
      if (!se) return;
      var card = se.closest('.acu-card');
      card.__acuSel[+se.getAttribute('data-acu-opt')] = se.value || null;
      syncCard(card);
    });
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; updateNav(); });
    }, { passive: true });
    window.addEventListener('resize', function () { if (modal.getAttribute('data-open') === 'true') updateNav(); });

    document.addEventListener('keydown', function (e) {
      if (modal.getAttribute('data-open') !== 'true') return;
      if (e.key === 'Escape') { e.preventDefault(); return close('dismiss'); }
      if (e.key !== 'Tab') return;
      // Keep focus inside the dialog.
      var f = Array.prototype.filter.call(
        modal.querySelectorAll('button:not([disabled]), select:not([disabled]), a[href]:not([tabindex="-1"]), [tabindex="0"]'),
        function (el) { return el.offsetParent !== null; }
      );
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  // QA hook: window.andlivyChainUpsell.preview('gold') opens it without a cart add.
  window.andlivyChainUpsell = {
    preview: function (finish) { return loadModal().then(function (m) { if (m) open(finish || null); return !!m; }); },
    reset: function () { try { sessionStorage.removeItem(SESSION_KEY); } catch (e) {} }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', maybePrefetch);
  else maybePrefetch();
})();
